<div class="character-item-cast-list-container">
  <div class="section-header">出演作品</div>
  <div class="item-list">
    @for (item of itemsWithRelation; track item) {
      <div class="ui segment item-card">
        <div class="image">
        <ui-responsive-image [src]="item.coverImage.url" [size]="{
            width: '100%',
            ratio: item.imageRatio,
            originalWidth: item.coverImage.width,
            originalHeight: item.coverImage.height
          }" [background]="item.coverImage.dormantColor"></ui-responsive-image>
        </div>
        <div class="name">{{item.nameCn || item.name}}</div>
        <div class="name-alt">{{item.nameCn ? item.name : ''}}</div>
        <div class="extra">
          <div class="ui label">{{item.type}}</div>
          <div class="public-time">{{item.publicTime}}</div>
        </div>
        <div class="cast-list">
          @for (cast of item.castList; track cast) {
            <div class="cast">
              <div class="image">
            <ui-responsive-image [src]="cast.coverImage.url" [size]="{
            width: '100%',
            ratio: cast.imageRatio,
            originalWidth: cast.coverImage.width,
            originalHeight: cast.coverImage.height
          }" [background]="cast.coverImage.dormantColor"></ui-responsive-image>
              </div>
              <div class="cast-name">{{cast.nameCn || cast.name}}</div>
            </div>
          }
        </div>
      </div>
    }
  </div>
</div>
